import { Directive, OnDestroy } from "@angular/core";
import { ReplaySubject } from "rxjs";

@Directive({
})
export class UnsubscribeOnDestroy implements OnDestroy {
    _unsubscribeAll: ReplaySubject<any> = new ReplaySubject<any>(1);
    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
    
}